import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import Footer from './Footer'
import '../Accueil.css'

class Informations extends Component {
state = {
    redirect:false,
    search: ''
    }

handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
}

render () {  
    return (
    <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <div className="histoire-content">
                        <h1><span>Informations générales</span></h1>   
                        <h2>BAIN LIBRE</h2>
                        <p className="pCenter">Le bain libre étant sous la responsabilité de la Ville de Montréal, veuillez donc communiquer avec eux au 514-872-1136<br/><br/>
                        </p>
                        <h2>ITEMS A VENDRE</h2>
                        <p className="pCenter">Pour votre commodité, nous vendons différents articles. Venez nous voir pour en connaitre les détails.<br/><br/>
                        </p>
                    </div>

                    </Col>
                    </Row>
                </Col>


            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <div className="fixed-bottom-footer"><Footer /></div>
            </Col>
            </Col>
        </Row>
        </Container>
    </>
    )
}
}

export default Informations
